import * as z from "zod";

export const uploadFormSchema = z.object({
  retailer: z.string().min(1, "Please select a retailer"),
  client: z.string().min(1, "Please select a client"),
  channel: z.string().min(1, "Please select a channel"),
  product: z.string().optional(),
});

export type UploadFormData = z.infer<typeof uploadFormSchema>;

export const PRODUCT_OPTIONS: Record<
  string,
  Array<{ label: string; value: string }>
> = {
  "ajinomoto-search": [
    { label: "All Products", value: "all" },
    { label: "Gyoza (Product-Specific Enhanced Report)", value: "gyoza" },
    { label: "Tai Pei", value: "taipei" },
    { label: "Jose Ole", value: "joseole" },
  ],
};
